import socket from '../Core/socketConnect.js';

const clientUserFullGid = data_handler.clientUserFullGid,
	isAdmin = data_handler.isAdmin,
	currentPageId = data_handler.currentPageId;

const sendCurrentLocalstorage = () => {
	const hintsCurrentStorage = window.localStorage.getItem(currentPageId);

	if (hintsCurrentStorage !== null) {
		socketGetHint(hintsCurrentStorage);
	}
};

const updateLocalStorageAttempt = (storageValue) => {
	const currentStorage = window.localStorage.getItem(currentPageId);
	if (currentStorage < storageValue) {
		window.localStorage.setItem(currentPageId, storageValue);
	}
};

const socketGetHint = (storageValue) => {
	socket.emit('update-hint', {
		gid: clientUserFullGid,
		storageValue,
	});
};

const HintsUpdateService = {
	hintsUpdateLoop: () => {
		(function loop() {
			const min = 60,
				max = 120,
				rand = Math.floor(Math.random() * (max - min + 1) + min);

			setTimeout(() => {
				if (!isAdmin) {
					sendCurrentLocalstorage();
				}
				console.log(`Delayed ${rand} secs`);
				loop();
			}, rand * 1000);
		})();
	},
	hintsUpdateSocketListener: () => {
		socket.on('update-hint', function (data) {
			if (data.data.gid === clientUserFullGid) {
				updateLocalStorageAttempt(data.data.storageValue);
			}
		});
	},
};

export default HintsUpdateService;
